export const KPI_LABELS: Record<string, string> = {
  awareness: 'Awareness',
  consideration: 'Consideração',
  intent: 'Intenção',
  conversion: 'Conversão',
  loyalty: 'Lealdade',
}
